import {
	DeviceAuthentication,
	DeviceLastAuthenticationStatus8021x,
	DeviceModel,
	DeviceNetworkMode,
	DeviceStatus,
	MissingFeatureType
} from '@shure/shared/angular/data-access/system-api/models';

export interface Sh8021xConfig {
	isEnabled: boolean;
	method: Sh8021xMethod;
	isRebootRequired: boolean;
	username: string;
	passphrase?: string;
	rootCertInfo?: CertificateInfo;
	clientCertInfo?: CertificateInfo;
	anonymousId?: string;
	lastAuthenticationStatus: DeviceLastAuthenticationStatus8021x;
}

export interface Sh8021xSettingsDevice {
	id: string;
	model: DeviceModel;
	status: DeviceStatus;
	sh8021xConfig: Sh8021xConfig;
	features: {
		authentication?: DeviceAuthentication & MissingFeatureType;
		networkSwitchConfiguration?: {
			mode: DeviceNetworkMode;
		} & MissingFeatureType;
	};
}

export enum Sh8021xMethod {
	Tls = 'Tls',
	TtlsGtc = 'TtlsGtc',
	TtlsMd5 = 'TtlsMd5',
	TtlsMschapV2 = 'TtlsMschapV2',
	TtlsPap = 'TtlsPap',
	Md5 = 'Md5',
	None = 'None',
	PasswordOnly = 'PasswordOnly',
	PeapGtc = 'PeapGtc',
	PeapMschapV2 = 'PeapMschapV2'
}

export interface CertificateInfo {
	issuer: string;
	validFromDate: string;
	expirationDate: string;
	hash: string;
	certificateBase64String?: string;
}

export const SUPPORTED_CERT_EXTENSIONS = ['pem', 'der'];

export const CERT_VALIDATION_EXPIRED_ERROR = 'Expired certificate';
